import { Div, Heading, P } from '@kizi/core-components';
import { Icon } from '@kizi/shared-components';
import React, { useMemo } from 'react';

export const Line = ({ text, key }) => (
  <Div alignItems="center" display="flex" key={`benefit-${key}`} mb={4}>
    <Icon name="checkmark" mr={2} variant="success" />
    <P variant="footnoteLight">{text}</P>
  </Div>
);

export interface UserDataSummary {
  title: string;
  address: string;
}

export interface ExpertData {
  title: string;
  expertBenefits: string[];
}

export interface SideNavProps {
  userData: UserDataSummary;
  expertData: ExpertData;
}

export const SideNav: React.FC<SideNavProps> = ({
  userData = { title: '', address: '' },
  expertData = { title: '', expertBenefits: [] },
}) => {
  const lines = useMemo(
    () =>
      expertData.expertBenefits.map((text, key) => (
        <Line text={text} key={key} />
      )),
    [expertData],
  );
  return (
    <>
      <Div variant="primaryContainer" color="text">
        <Div variant="innerSideNav">
          <Heading variant="H4" as="h4">
            {userData.title}
          </Heading>
          <P>{userData.address}</P>
          <Div>
            <P variant="footnoteImportant">
              +3 maanden gratis Basislidmaatschap
            </P>
            <P>Daarna €3 per maand (maandelijks opzegbaar)</P>
          </Div>
        </Div>
      </Div>
      <Div variant="secondaryCard" mt="6">
        <Heading variant="H6" as="h6" color="white" mb={4} mt="0">
          {expertData.title}
        </Heading>
        {lines}
      </Div>
    </>
  );
};

export default SideNav;
